import { useQueryParam } from './queryParams';

/**
 * Check if the current page is being shown becaues of the Workflow API.
 *
 * ---
 *
 * Example URLs for the Workflow API experience, owned by #team-partner-sharing.
 * The Workflow API is identified here based on the query parameter
 * `utm_campaign=workflow_api`. See below for a full example of URL parameters:
 *
 * ```ini
 * utm_campaign=workflow_api
 * utm_content=Google+Drive
 * utm_source=partner
 * utm_medium=embed
 * referer=GoogleDriveCLIAPI%401.11.0
 * email=faker.XXXX%40zapier.rodeo
 * firstName=Firsty
 * lastName=Lasty
 * skipOnboarding=true
 * userProvisioningMethod=partner_quick_account_creations
 * next=<removed to save space>
 * ```
 *
 * https://zapierorg.atlassian.net/browse/TPS-4369
 *
 * Full Workflow API Example URL: (replace XXXX with a unique number)
 *
 * https://api.zapier.com/v2/authorize?scope=zap&client_id=S0uEx8i8PVcZ23KhTVg1BlgO27Q1ZusTkkn8SoWQ&sign_up_email=faker.XXXX%40zapier.rodeo&sign_up_first_name=Firsty&sign_up_last_name=Lasty& *direct_uri=https%3A%2F%2Fzapier.com&response_type=code&template=69
 *
 * Staging Workflow API Example URL: (replace XXXX with a unique number)
 *
 * https://api.zapier-staging.com/v2/authorize?scope=zap&client_id=3U9sKmHy0x3U9CoVro5t0psxANZQkAaOHWNYoyk4&sign_up_email=faker.XXXX%40zapier.rodeo&sign_up_first_name=Firsty&sign_up_last_name=Lasty& *direct_uri=https%3A%2F%2Fexample.com%2Ffoo&response_type=code&template=69
 */
export function useIsWorkflowAPI() {
  const utmCampaign = useQueryParam('utm_campaign');
  return utmCampaign === 'workflow_api';
}
